<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content contact-section background-light">
			<div class="row contact-form-row">
				<div class="columns column6 contact-form-col">
					<contact-form name="meetingform" :form="form" />
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:items="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: form } = await useWebsiteFetch('meetingform', {
	query: { language: locale.value },
	key: `${locale.value}/meetingform`,
});
</script>

<style scoped lang="scss">
.error {
	color: red;
}

.mx-datepicker {
	width: 100%;
}

form {
	input:not([type='submit'], [disabled]),
	textarea,
	select {
		background-color: #fff;
		appearance: none;
		width: 100%;
		padding: 25px;
		margin: 5px 0;
		border: 1px solid #efefef;
	}

	input,
	textarea,
	label,
	:deep(input),
	select {
		width: 100%;
		padding: 25px;
		margin: 5px 0;
		border: 1px solid #efefef;
	}

	:deep(.mx-input) {
		height: auto;
		font-size: unset;
		color: unset;

		&:focus,
		&:hover {
			border-color: transparent;
		}

		&:focus {
			outline: revert;
		}
	}

	input.button {
		width: auto;
		padding: 10px 25px;
		appearance: none;
		border: none;
		outline: none;
	}

	label {
		padding: 20px 0 5px;
		display: block;
		border: none;
	}

	select {
		width: 100%;
		font-size: 15px;
	}
}

.checkboxes {
	display: flex;
	margin: 5px 0 10px;

	label,
	input {
		width: auto;
		padding: 0;
		font-size: 0.9em;
	}

	.extra-option {
		width: 100%;
		padding: 25px;
		margin: 5px 0;
		border: 1px solid #fff;
	}

	label {
		margin: 0 5px 0 0;
		display: flex;
		gap: 10px;
		align-items: center;

		input {
			width: auto;
			padding: 0;
			appearance: auto;
			margin: -2px 6px 0 0;
		}
	}
}

.radiobuttons {
	display: flex;
	flex-flow: row wrap;
	margin: 5px 0 10px;

	> div {
		width: 100%;
		margin: 0 0 10px;
	}

	label,
	input {
		width: auto;
		padding: 0;
		font-size: 0.9em;
	}

	label {
		margin: 0 5px 0 0;
		display: flex;
		gap: 10px;

		input {
			width: auto;
			appearance: auto;
			margin: -2px 6px 0 0;
			padding: 0;
		}
	}
}

@media (max-width: 900px) {
	.contact-section {
		padding-top: 0;
	}

	.main-content#intro {
		padding-bottom: 15px;
	}
}
</style>
